import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

const Container = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding: 0 ${tokens.spacing[500]};
`;

export default Container;
